export const paginationListLimit = 50;
export const paginationSmallListLimit = 15;
